import { DirectiveBase } from '../angular-directive-base.directive';

/**
 * Renders a status label highlighted with an appropriate colour. The label can optional show only an icon if configured to do so.
 */
export class StatusLabel extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'E';
    this.controller = 'StatusLabelController';
    this.controllerAs = 'vm';
    this.bindToController = true;
    this.scope = {
      status: '=',
      iconOnly: '='
    };
    this.template =
      '<span ng-if="!vm.iconOnly" hide show-gt-sm ng-class="vm.status | statusClass" layout="row" layout-align="center center">' +
      ' <span translate>{{"STATUSES." + vm.status}}</span>' +
      '</span>' +
      '<md-icon ng-if="!vm.iconOnly" hide show-xs show-sm class="material-icons" ng-class="status | statusClass">{{vm.status | statusClass | statusIcon}}</md-icon>' +
      '<md-icon ng-if="vm.iconOnly" class="material-icons" ng-class="vm.status | statusClass">{{vm.status | statusClass | statusIcon}}</md-icon>';
  }
}